import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  BASE_URL_SANDBOX,
  GET_ALL_LOYALTY_POINT_HISTORY,
  LOYALTY_TOTAL_COUNT,
  STORE_CREDIT_HISTORY,
  TOTAL_LOYALTY_POINTS,
} from '../../../Constants/Config';

const initialState = {
  loading: false,
  loyaltyPointData: [],
  historyData: [],
  successMessage: '',
  error: '',
  hasMore: '',
  offset: '',
  totalLoyaltyPointsLoading: '',
};

// Generate pening , fulfilled and rejected action type
export const fetchLoyaltyPointData = createAsyncThunk(
  'loyaltyPoint/fetchLoyaltyPointData.',
  async (data) => {
    try {
      const response = await axios.post(
        BASE_URL_SANDBOX + GET_ALL_LOYALTY_POINT_HISTORY,
        data,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );
      if (response.data.status === true) {
        return response.data;
      } else {
        return [];
      }
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },
);

// Generate pening , fulfilled and rejected action type
export const fetchHistoryData = createAsyncThunk(
  'loyaltyPoint/fetchHistoryData.',
  async (data) => {
    const { payload, endpoints } = data;
    try {
      const response = await axios.post(BASE_URL_SANDBOX + endpoints, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.data.status === true) {
        return response.data;
      } else {
        return [];
      }
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },
);

// Generate pening , fulfilled and rejected action type
export const totalLoyaltyPoints = createAsyncThunk(
  'loyaltyPoint/totalLoyaltyPoints.',
  async (payload) => {
    const { totalValuePayload } = payload;
    try {
      const response = await axios.post(
        BASE_URL_SANDBOX + TOTAL_LOYALTY_POINTS,
        totalValuePayload,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      );
      if (response.data.status === true) {
        return response?.data?.total_lp_data;
      } else {
        return [];
      }
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },
);

// fetchTotal Count API
export const fetchTotalCountAPI = createAsyncThunk(
  'loyaltyPoint/fetchTotalCountAPI.',
  async (data) => {
    const { payload, endpoints } = data;
    try {
      const response = await axios.post(BASE_URL_SANDBOX + endpoints, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.data.status === true) {
        return response.data;
      } else {
        return { status: false, count: 0 };
      }
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },
);

const loyaltyPointSlice = createSlice({
  name: 'loyaltyPoint',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchLoyaltyPointData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchLoyaltyPointData.fulfilled, (state, action) => {
      state.loading = false;
      state.loyaltyPointData = action.payload;
      state.error = '';
    });
    builder.addCase(fetchLoyaltyPointData.rejected, (state, action) => {
      state.loading = false;
      state.loyaltyPointData = [];
      state.error = action.error.message;
    });
    builder.addCase(fetchHistoryData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchHistoryData.fulfilled, (state, action) => {
      state.loading = false;
      state.historyData = action.payload;
      state.error = '';
    });
    builder.addCase(fetchHistoryData.rejected, (state, action) => {
      state.loading = false;
      state.historyData = [];
      state.error = action.error.message;
    });

    // totalLoyaltyPoints

    builder.addCase(totalLoyaltyPoints.pending, (state) => {
      state.totalLoyaltyPointsLoading = true;
    });
    builder.addCase(totalLoyaltyPoints.fulfilled, (state, action) => {
      state.totalLoyaltyPointsLoading = false;
    });
    builder.addCase(totalLoyaltyPoints.rejected, (state, action) => {
      state.totalLoyaltyPointsLoading = false;
    });
  },
});

export default loyaltyPointSlice.reducer;
